export default {
  driver_performance_dashboard: "Dashboard",
  driver_performance_driver: "Drivers",
  driver_performance_events: "Events",
  driver_performance_cases: "Cases",

  //Events
  driver_performance_Asleep: "Asleep",
  driver_performance_CameraObstructed: "Camera Obstructed",
  driver_performance_CloseFollowing: "Close Following",
  driver_performance_CollisionWarning: "Collision Warning",
  driver_performance_CyclistWarning: "Cyclist Warning",
  driver_performance_Distracted: "Distracted",
  driver_performance_Drowsiness: "Drowsiness",
  driver_performance_HardAcceleration: "Hard Acceleration",
  driver_performance_HardBrake: "Hard Brake",
  driver_performance_HardTurn: "Hard Turn",
  driver_performance_IdleNoDriver: "Idle No Driver",
  driver_performance_LaneDeparture: "Lane Departure",
  driver_performance_NoSeatbelt: "No Seatbelt",
  driver_performance_ParkingHit: "Parking Hit",
  driver_performance_PassengerInside: "Passenger Inside",
  driver_performance_PassengerSeatbelt: "Passenger Seatbelt",
  driver_performance_PedestrianDetection: "Pedestrian Detection",
  driver_performance_PostedSpeed: "Posted Speed",
  driver_performance_PotentialIncident: "Potential Incident",
  driver_performance_RapidAcceleration: "Rapid Acceleration",
  driver_performance_Smoking: "Smoking",
  driver_performance_SpeedThreshold: "Speed Threshold",
  driver_performance_StopSignViolation: "Stop Sign Violation",
  driver_performance_Tailgating: "Tailgating",
  driver_performance_UsingPhone: "Using Phone",
  driver_performance_Yawn: "Yawn",
  driver_performance_PotentialIncidentMedium: "Potential Incident",
  driver_performance_PotentialIncidentHigh: "Potential Incident",
  driver_performance_PotentialIncidentLow: "Potential Incident",
  driver_performance_UnassignedDriver: "Unassigned Driver",
  driver_performance_SpeedOverPosted: "Speed Over Posted",
  driver_performance_ECUSpeedOverPosted: "ECU Speed Over Posted",
  driver_performance_SpeedOver: "Speed Over",
  driver_performance_UsingPhone: "Using Phone",
  driver_performance_SDCardError: "SD Card Error",
  driver_performance_PowerLost: "Power Lost",
  driver_performance_ParkingHit: "Parking Hit"
};
